module.exports = __webpack_public_path__ + "static/connect-shopify-to-google-analytics-f9d40b31120f4fd0e095e1e2dad1bc0b.jpg";